export default "__VITE_ASSET__r9BL0NQz__"